import React, { createContext, useContext, useEffect, useState } from "react";

const PageDataContext = createContext({
  pageTitle: "",
  setPageTitle: () => {},
  pageBreadcrumbs: [],
  setPageBreadcrumbs: () => {},
  actionButtons: [],
  setActionButtons: () => {},
  actionGroupButtons: [],
  setActionGroupButtons: () => {},
  saveButton: { showButton: false, onClick: () => {} },
  setSaveButton: () => {},
});

function PageDataProvider({ children }) {
  const [pageTitle, setPageTitle] = useState("");
  const [pageBreadcrumbs, setPageBreadcrumbs] = useState([]);
  const [actionButtons, setActionButtons] = useState([]);
  const [actionGroupButtons, setActionGroupButtons] = useState([]);
  const [saveButton, setSaveButton] = useState({
    showButton: false,
    onClick: () => {},
  });

  const value = {
    pageTitle,
    setPageTitle,
    pageBreadcrumbs,
    setPageBreadcrumbs,
    actionButtons,
    setActionButtons,
    actionGroupButtons,
    setActionGroupButtons,
    saveButton,
    setSaveButton,
  };
  return (
    <PageDataContext.Provider value={value}>
      {children}
    </PageDataContext.Provider>
  );
}

function usePageData() {
  return useContext(PageDataContext);
}

function PageSubHeader({
  title,
  breadcrumbs,
  actionButtons,
  actionGroupButtons,
  saveButton,
}) {
  const {
    setPageTitle,
    setPageBreadcrumbs,
    setActionButtons,
    setActionGroupButtons,
    setSaveButton,
  } = usePageData();

  useEffect(() => {
    if (title) {
      setPageTitle(title);
    }
  }, [title]);

  useEffect(() => {
    if (breadcrumbs) {
      setPageBreadcrumbs(breadcrumbs);
    }
  }, [breadcrumbs]);

  useEffect(() => {
    if (actionGroupButtons && actionGroupButtons.length > 0) {
      setActionGroupButtons(actionGroupButtons);
    } else {
      setActionGroupButtons([]);
    }
  }, [actionGroupButtons]);

  useEffect(() => {
    if (actionButtons) {
      setActionButtons(actionButtons);
    }
  }, [actionButtons]);

  useEffect(() => {
    if (saveButton) {
      setSaveButton(saveButton);
    } else {
      setSaveButton({ showButton: false });
    }
  }, [saveButton]);

  return <></>;
}

export { usePageData, PageSubHeader, PageDataProvider };
